"use strict";
module.exports = require('../../module.compiled').vendored['react-ssr'].ReactServerDOMWebpackClient;

//# sourceMappingURL=react-server-dom-webpack-client.js.map